export default {
  name: 'dashify:TestTemplate',
  title: 'Test',
  owner: 'System',
  solution: '',
  tags: ['html', 'test'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    view: [['dashify:Test', { prop: 1, prop2: 'string', prop3: { a: 'a', b: 'b' } }, 'Go To URL']],
  },
};
